import React from 'react';
import { theme } from '../theme';
import { pillStyle, INFO_PILL_BORDER_WIDTH } from './SecondaryAxisPills';
import { InfoTooltip } from './InfoTooltip';
import { STUFE_FACE, STUFE_HOVER } from '../words';

export const StufeChip: React.FC<{
  n: number;
  variant?: 'row' | 'detail';
  style?: React.CSSProperties;
}> = ({ n, variant = 'row', style }) => {
  if (!(n >= 1)) return null;
  // The face states the same whole step the hover names — a fractional n never prints a half step.
  const step = Math.min(Math.floor(n), 3) as 1 | 2 | 3;
  return (
    <InfoTooltip text={STUFE_HOVER[step]}>
      <span
        data-testid="stufe-chip"
        style={{
          ...pillStyle('info', variant),
          fontWeight: 600, letterSpacing: '0.08em',
          color: theme.colors.navyMid, backgroundColor: theme.colors.white, border: `${INFO_PILL_BORDER_WIDTH} solid ${theme.colors.navyMid}`,
          ...style,
        }}
      >
        {STUFE_FACE[step]}
      </span>
    </InfoTooltip>
  );
};
